import React from 'react';
import { useBaseStore } from '@roc/feature-app-core';

const HEADER_HEIGHT = 75;
const CRM_PORTAL_HEADER_HEIGHT = 100;
const SLIM_HEADER_HEIGHT = 48;

// Impersonation bar (ImpersonateHeader): sits this far inside the red frame, at this height.
export const IMPERSONATION_FRAME_GAP = 6;
export const IMPERSONATION_BAR_HEIGHT = 52;
// How far the navigation (and therefore the page) moves down while impersonating:
// the bar plus its top gap; the nav keeps its own 4px inset below the bar.
export const IMPERSONATION_OFFSET = IMPERSONATION_FRAME_GAP + IMPERSONATION_BAR_HEIGHT;

/** Extra top offset while impersonating (0 otherwise). */
export const useImpersonationOffset = () => {
  const { globalStore } = useBaseStore();
  return globalStore.impersonatedUser ? IMPERSONATION_OFFSET : 0;
};

/** Total height reserved at the top of the page: navigation plus the impersonation bar when shown. */
export const useHeaderHeight = () => {
  const { globalStore } = useBaseStore();
  const impersonationOffset = useImpersonationOffset();
  const { showNavigation, slimNavigation, isBorrowerPortal, isCrmPortal } = globalStore;
  if (isBorrowerPortal) {
    return 0;
  }
  if (!showNavigation) {
    return 0;
  }
  const navHeight = slimNavigation ? SLIM_HEADER_HEIGHT : isCrmPortal ? CRM_PORTAL_HEADER_HEIGHT : HEADER_HEIGHT;
  return navHeight + impersonationOffset;
};
